export default {
    methods: {
        formatDateTime(dateTime) {
            const momentDate = moment(dateTime);

            if (!momentDate.isValid()) {
                return '';
            }

            if (this.$i18n.locale == 'en') {
                return momentDate.format('D MMM YYYY hh:mm A');
            }

            return momentDate.format('D MMM YYYY HH:mm');
        },
    },
};
